<template>
  <v-container fill-height fluid>
    <v-row>
      <v-col
        cols="12"
        class="col-lg-6 offset-lg-3"
        justify="center"
        align="center"
      >

				<!-- <div class="w-full mb-4">
					<v-btn color="primary" href="https://www.pickaservice.ky/" outlined>
						Back to Home
					</v-btn>
				</div> -->

				<a href="https://www.pickaservice.ky/">
					<img
						src="@/assets/logo.png"
						align-center
						justify-center
						width="200px"
						class="mb-10"
					/>
				</a>
        <v-text-field
          outlined
          append-icon="mdi-magnify"
          v-model="accessCode"
          label="Access Code"
          color="secondary"
          @click:append="redirectToDetails"
          @keydown.enter="redirectToDetails"
        ></v-text-field>
				<!-- <GuideDialog /> -->
				<div class="mt-5 body-1 steps">
					<p>
						1. Please ensure that you are tracking your shipment from the vendors
						you purchase from, to determine how many packages you expect to
						receive.
					</p>

					<p>
						2. Ensure that all your packages are listed on our tracking portal. Do
						not rely on notifications that you receive from the vendor alone.
					</p>

					<p>
						3. If you don't see a package listed within 48 hours after you have
						been notified it as delivered. Please contact us with the tracking
						number in dispute.
					</p>

					<p>
						4. We will not ship your package until you upload your invoice(s) and
						click “Proceed to Ship”.
					</p>

					<p>
						5. If you are planning on consolidating your shipment, only click
						“Proceed to Ship” once all of your packages are reflected on our
						tracking portal.
					</p>

					<p>
						6. Our ocean freight services cut off time is every Thursday at
						5pm. Please ensure to upload your invoice(s) and click “Proceed to
						Ship” before the deadline.
					</p>

					<p>
						7. For air freight services, our cut off time is every Monday at 5pm. 
						Please ensure to upload your invoice(s) and click "Proceed to Ship" before the deadline.
					</p>
				</div>
      </v-col>
    </v-row>
  </v-container>
</template>

<style>
.steps {
	text-align: justify;
	max-width: 600px;
	color: rgba(0, 0, 0, 0.6);
}
</style>

<script>
import GuideDialog from "../../components/GuideDialog";

export default {
  name: 'TrackerForm',

  components: {
    // GuideDialog,
  },

  data: () => ({
    accessCode: ""
  }),

  mounted() {
  },

  methods: {
    redirectToDetails: function () {
      if (this.accessCode.length > 0) {
        this.$router.push({
          name: 'tracker-details',
          params: { accessCode: this.accessCode }
        })
      }
    },
  },
}
</script>
